import {gsap} from "gsap";
import {TheCageGameAssets} from "../../TheCageGameAssets";
import {TheCage} from "../../TheCage";
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";
import {TheCageSound} from "../../sound/TheCageSound";

interface FreespinsOpponent extends PIXI.Container {
    init(): void;
    reveal(): gsap.core.Timeline;
    idle(): gsap.core.Timeline;
    getPunched(punches: number): gsap.core.Timeline;
    // maybe defeat animations
}

// khabib
class FreespinsOpponent extends PIXI.Container implements FreespinsOpponent {
    //private maxBeatUpLevel = Octagon.model.initData.nBNcollectedInFS[0]
    // TODO change this so it actually matches the level of the freespins
    // since there is no getting hit animation available yet it doesnt matter for now
    protected maxBeatUpLevel: number;
    protected beatUpLevel: number;
    protected fighterSpine: PIXI.spine.Spine;

    constructor(spineAsset:string, maxBeatUpLevel: number) {
        super();
        // setup spine meme
        this.fighterSpine = new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(spineAsset));
        this.maxBeatUpLevel = maxBeatUpLevel;
        this.addChild(this.fighterSpine);
        this.init()
    }

    public init():void {
        this.beatUpLevel = 0;
        this.idle();
    }

    public setBeatUpLevel(level: number) {
       this.beatUpLevel = level;
    }

    public reveal(): gsap.core.Timeline {
        // play reveal animation
        this.idle()
        return gsap.timeline();
    }

    public idle(): gsap.core.Timeline {
        // start idle animation
        const tl = gsap.timeline();
        if (this.beatUpLevel != this.maxBeatUpLevel) {
            tl.add(() => {
                this.fighterSpine.state.setAnimation(0, "idle", true);
            })
        } else {
            tl.add(() => {this.fighterSpine.state.setEmptyAnimation(0, 0)});
        }
        return gsap.timeline() ;
    }

    public getPunched(punches: number): gsap.core.Timeline {
        // actually get punched lol
        const tl = gsap.timeline();
        const actualPunches = Math.min(punches, this.maxBeatUpLevel - this.beatUpLevel);
        this.beatUpLevel += actualPunches;
        for (let i = 0; i < actualPunches; i++) {
            if (this.beatUpLevel == this.maxBeatUpLevel) {
                tl.add(SpineGSAPWrapper.createTimeline(this.fighterSpine, 0, `knockOut`, 0, 1, 0.1));
                tl.add(() => {
                    TheCage.soundPlayer.playSound(TheCageSound.FS_PUNCH_FINAL);
                    TheCage.backgroundElements.getBounceShake();
                }, '<0.09');

            } else {
                tl.add(SpineGSAPWrapper.createTimeline(this.fighterSpine, 0, `hit${this.beatUpLevel}`, 0, 1, 0.1));
                tl.add(() => {TheCage.soundPlayer.playSound(TheCageSound.FS_PUNCH.next())}, '<0.09');
            }
        }
        tl.add(this.idle());
        return tl;
    }
}

class FreespinsOpponentLvl1 extends FreespinsOpponent {
    constructor(spineAsset:string, maxBeatUpLevel: number) {
        super(spineAsset, maxBeatUpLevel);
    }

    public idle(): gsap.core.Timeline {
        const tl = gsap.timeline();
        if (this.beatUpLevel != this.maxBeatUpLevel) {
            // make sure we bind the current beatUpLevel to the lambdas being put in the timeline
            const levelWorkaround = this.beatUpLevel;
            if (this.beatUpLevel == 0) {
                tl.add(() => {this.fighterSpine.state.setAnimation(0, "idle", true)});
            } else {
                tl.add(() => {this.fighterSpine.state.setAnimation(0, `idle${Math.min(3,levelWorkaround + 1)}`, true)});
            }
        } else {
            tl.add(() => {this.fighterSpine.state.setAnimation(0, "knockOut_idle", true)});
        }
        return tl;
    }
}

class FreespinsOpponentLvl2 extends FreespinsOpponent {
    constructor(spineAsset:string, maxBeatUpLevel: number) {
        super(spineAsset, maxBeatUpLevel);
    }

    public idle(): gsap.core.Timeline {
        const tl = gsap.timeline();
        if (this.beatUpLevel != this.maxBeatUpLevel) {
            // make sure we bind the current beatUpLevel to the lambdas being put in the timeline
            const levelWorkaround = this.beatUpLevel;
            if (this.beatUpLevel == 0) {
                tl.add(() => {this.fighterSpine.state.setAnimation(0, "idle", true)});
            } else {
                tl.add(() => {this.fighterSpine.state.setAnimation(0, `idle${Math.min(3,levelWorkaround + 1)}`, true)});
            }
        } else {
            tl.add(() => {this.fighterSpine.state.setAnimation(0, "knockOut_idle", true)});
        }
        return tl;
    }
}

class FreespinsOpponentLvl3 extends FreespinsOpponent {
    constructor(spineAsset:string, maxBeatUpLevel: number) {
        super(spineAsset, maxBeatUpLevel);
    }

    public idle(): gsap.core.Timeline {
        const tl = gsap.timeline();
        if (this.beatUpLevel != this.maxBeatUpLevel) {
            if (this.beatUpLevel == 0) {
                tl.add(() => {
                    this.fighterSpine.state.setAnimation(0, "idle", true);
                });
            } else {
                const idleLevel = this.beatUpLevel > 1 ? 3 : 2;
                tl.add(() => {
                    this.fighterSpine.state.setAnimation(0, `idle${idleLevel}`, true);
                });
            }
        } else {
            tl.add(() => {this.fighterSpine.state.setAnimation(0, "knockOut_idle", true)});
        }
        return tl;
    }
}

class FreespinsOpponentLvl4 extends FreespinsOpponent {
    constructor(spineAsset:string, maxBeatUpLevel: number) {
        super(spineAsset, maxBeatUpLevel);
    }

    public idle(): gsap.core.Timeline {
        const tl = gsap.timeline();
        if (this.beatUpLevel != this.maxBeatUpLevel) {
            if (this.beatUpLevel == 0) {
                tl.add(() => {
                    this.fighterSpine.state.setAnimation(0, "idle", true);
                });
            } else {
                const idleLevel = this.beatUpLevel > 2 ? 3 : 2;
                tl.add(() => {
                    this.fighterSpine.state.setAnimation(0, `idle${idleLevel}`, true);
                });
            }
        } else {
            tl.add(() => {this.fighterSpine.state.setAnimation(0, "knockOut_idle", true)});
        }
        return tl;
    }
}

export class FreespinsOpponentDelegate extends PIXI.Container {
    private fighters: FreespinsOpponent[];
    private currentFighter: FreespinsOpponent;

    constructor() {
        super();
        this.fighters = [
            new FreespinsOpponentLvl1(TheCageGameAssets.FreespinsOpponent1, TheCage.model.initData.BN_LEVEL_FS[0]),
            new FreespinsOpponentLvl2(TheCageGameAssets.FreespinsOpponent2, TheCage.model.initData.BN_LEVEL_FS[1]),
            new FreespinsOpponentLvl3(TheCageGameAssets.FreespinsOpponent3, TheCage.model.initData.BN_LEVEL_FS[2]),
            new FreespinsOpponentLvl4(TheCageGameAssets.FreespinsOpponent4, TheCage.model.initData.BN_LEVEL_FS[3]),
            new FreespinsOpponent(TheCageGameAssets.FreespinsOpponent5, 99),
        ];
        //this.init(0);
    }

    public init(level: number):void {
        this.removeChildren(0);
        this.currentFighter = this.fighters[level];
        this.currentFighter.init();
        this.currentFighter.position.set(360, 360);
        this.currentFighter.name = "freespinsOpponent";
        this.addChild(this.currentFighter)
    }

    restore(level:number, beatUpLevel: number) {
       this.init(level);
       this.currentFighter.setBeatUpLevel(beatUpLevel);
    }

    // details about the reveal, most likely skip "darkened idle" and just reveal from darkened then regular idle
    public reveal(): gsap.core.Timeline {
        return this.currentFighter.reveal();
    }

    public idle(): gsap.core.Timeline {
        return this.currentFighter.idle();
    }

    public getPunched(punches: number): gsap.core.Timeline {
        return this.currentFighter.getPunched(punches);
    }
}